import { PLUGIN_TEMPLATES_COLUMN_ID } from "../constants";
import PluginTemplatesTableActionsCell from "./ActionsCell";
import PluginTemplatesTableCreatedAtCell from "./CreatedAtCell";
import PluginTemplatesTableDescriptionCell from "./DescriptionCell";
import PluginTemplatesTableLabelsCell from "./LabelsCell";
import PluginTemplatesTableNameCell from "./NameCell";

export const pluginTemplatesTableCells = {
  [PLUGIN_TEMPLATES_COLUMN_ID.NAME]: PluginTemplatesTableNameCell,
  [PLUGIN_TEMPLATES_COLUMN_ID.LABELS]: PluginTemplatesTableLabelsCell,
  [PLUGIN_TEMPLATES_COLUMN_ID.DESCRIPTION]: PluginTemplatesTableDescriptionCell,
  [PLUGIN_TEMPLATES_COLUMN_ID.CREATED_AT]: PluginTemplatesTableCreatedAtCell,
  [PLUGIN_TEMPLATES_COLUMN_ID.DROPDOWN]: PluginTemplatesTableActionsCell,
};
